import { render, staticRenderFns } from "./BaseModalFooter.vue?vue&type=template&id=1511b9bc&scoped=true&"
import script from "./BaseModalFooter.vue?vue&type=script&lang=js&"
export * from "./BaseModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalFooter.vue?vue&type=style&index=0&id=1511b9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1511b9bc",
  null
  
)

export default component.exports